import { db } from "../../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const AgentVisits = async (agentId) => {
  /**
   * input: null
   * output: agent visits array
   * description: fetches All agent visits
   */
  try {
    const visitsCollection = collection(db, "visits");
    const q = query(
      visitsCollection,
      // where("bid", "==", getLocalStorageItem("bid")),
      where("agentId", "==", agentId)
    );
    const AgentVisitsSnapshot = await getDocs(q);

    let AgentVisits = [];
    AgentVisitsSnapshot.docs.forEach((e) =>
      AgentVisits.push({ ...e.data(), id: e.id })
    );

 

    return AgentVisits;
  } catch (error) {
    console.log(error);
    return [];
  }
};

export default AgentVisits;
